import { BlueprintInput, BlueprintInputType } from "types/generated";

import { VersionTemplateFormFields } from "../components/DeploymentForm/types";

/**
 * Builds merged inputs when switching versions:
 * - Preserves current form value for fields that still exist in the new version.
 * - Uses the new version's default value for fields that didn't exist before.
 * - Fields removed from the new version are not included.
 */
export const buildMergedVersionInputs = (
  newVersionInputs: BlueprintInput[],
  currentInputValues: VersionTemplateFormFields["inputs"]
): VersionTemplateFormFields["inputs"] => {
  return newVersionInputs.reduce(
    (acc, input) => {
      const currentValue = currentInputValues[input.id];
      if (currentValue !== undefined) {
        acc[input.id] = currentValue;
      } else if (input.type === BlueprintInputType.Boolean) {
        acc[input.id] = input.default === "true";
      } else {
        acc[input.id] = input.default;
      }
      return acc;
    },
    {} as VersionTemplateFormFields["inputs"]
  );
};
